import { Col, Row } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import image from "../../../../images/register.svg";
import { useMemo } from "react";

export const Description = () => {
  const titles: string[] = useMemo(() => {
    return [
      "Get up-to-date account information",
      "View transactions history",
      "Make secure payments",
    ];
  }, []);

  return (
    <Col className="singup-left__container">
      <h5 className="h h5 mb-10">Creating trust between strangers</h5>
      {titles.map((item: string, i: number) => (
        <Row className="mb-4" key={i}>
          <CheckOutlined className="ant-btn-link" />
          <p className="pl-4 my-0">{item}</p>
        </Row>
      ))}
      <div className="mt-3">
        <img src={image} alt="register" />
      </div>
    </Col>
  );
};
